// extracted by mini-css-extract-plugin
export default {"container":"XKud2HILbKvajCf5mYAG"};